module.exports = __webpack_public_path__ + "static/media/twitter.9af8aee4.svg";